import React from "react";
import {inject, observer} from "mobx-react";
import {observable, computed} from "mobx";
import {Box, Tab, Tabs} from "@material-ui/core";
import {IManagementStore} from "Stores/Management/types";
import filterByTableColumns from "@src/Tools/filterByTableColumns";
import PositionsTable from "./PositionsTable/PositionsTable";
import ResultsAreEmpty from "@src/Components/Ui/ResultsAreEmpty";
import {Values} from "@src/Tools/Values";
import {Position} from "@src/Interfaces/Entity/Position";
import {IAuthStore} from "@src/Stores/Auth/types";
import {IValuesStore} from "Stores/Values/types";
import {FullWidthFlexBox} from "@src/Shared/Components/FullWidthFlexBox";
import {STFormContentWrapper, STTabsContentWrapper} from "@src/Components/Pages/Main/Content/OAuth/styles";
import {AddButton} from "@src/Shared/Components/AddButton/AddButton";
import FullWidthSearch from "@src/Shared/Components/FullWidthSearch/FullWidthSearch";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import PositionForm from "@src/Components/Pages/Main/Content/Positions/PositionForm/PositionForm";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("auth", "management", "values")
@observer
class PositionsContent extends React.Component<IProps> {
  @observable searchText: string = "";
  @observable showPositionDialog: boolean = false;
  @observable isEdit: boolean = false;
  @observable editPosition: Position = null;

  @computed get filteredPositions() {
    return filterByTableColumns<Position>(
      this.props.management.positions,
      this.searchText
    );
  }

    handleFilterChange(text: string) {
        this.searchText = text;
    }

    handleAddPositionDialog() {
        this.editPosition = new Position();
        this.editPosition.state = this.props.values.states.Active;
        this.editPosition.permissionGroup = "";
        this.editPosition.permissionGroupWhenActivelyAssigned = "";
        this.showPositionDialog = true;
    }

    handleEditPositionDialog(position: Position) {
        this.editPosition = position;
        this.isEdit = true;
        this.showPositionDialog = true;
        
    }

    async onSave(values: Position) {
        try {
            await this.props.management.savePosition(values, !this.isEdit);
            this.onClose();
        } catch (error) {
            console.error(error);
        }
    }

    onClose() {
        this.showPositionDialog = false;
        this.isEdit = false;
    }

    render() {
        return (
            <>
                <FullWidthFlexBox>
                    <STTabsContentWrapper>
                        <Tabs
                            value={0}
                            indicatorColor="primary"
                            textColor="primary"
                            variant={"standard"}
                        >
                            <Tab label={Values.getLocalizationValue("positionTypes")}/>
                        </Tabs>
                    </STTabsContentWrapper>

                    {this.props.auth.user.location.primary &&
                        <AddButton
                            onClick={() => this.handleAddPositionDialog()}
                            text={Values.getLocalizationValue("addPositionType")}
                        />
                    }
                </FullWidthFlexBox>

                <STFormContentWrapper>
                    <Box>
                        <FullWidthSearch
                            value={this.searchText}
                            onChange={(text: string) => this.handleFilterChange(text)}
                        />

                        {this.filteredPositions.length > 0 ? (
                            <PositionsTable
                                onEditButtonClick={(position) => this.handleEditPositionDialog(position)}
                                positions={this.filteredPositions}
                            />
                        ) : (
                            <ResultsAreEmpty/>
                        )}
                    </Box>
                </STFormContentWrapper>

                <SimpleModal width={710} isOpened={this.showPositionDialog} onClose={() => this.onClose()}>
                    <PositionForm
                        title={Values.getLocalizationValue(this.isEdit ? "editPositionType" : "addPositionType")}
                        initialValues={this.editPosition}
                        onClose={() => this.onClose()}
                        onSubmit={(position) => this.onSave(position)}
                    />
                </SimpleModal>
            </>
        );
    }
}

export default PositionsContent;
